import { lazy } from "react";

export const NodeView = lazy(() => import("pages/AssetView/NodeView"));
export const CloudView = lazy(() => import("pages/CloudView/CloudView"));
export const Groups = lazy(() => import("pages/Admin/Groups"));
export const ThingType = lazy(() => import("pages/Admin/ThingType"));
export const Users = lazy(() => import("pages/Admin/Users/Users"));
export const PlatformUserAccess = lazy(
  () => import("pages/PlatformUserAccess")
);
